import { Input } from "@/components/ui/input";
import { getCurrencySymbol, normalizeCurrency } from "@/lib/currency";

export function PriceField({ label = "Price", testId, value, onChange, currency, readOnly = false, type = "text", compact = false }) {
  const symbol = getCurrencySymbol(normalizeCurrency(currency));

  return (
    <div>
      {!compact && (
        <label htmlFor={testId} data-testid={`${testId}-label`} className="text-sm font-bold">{label}</label>
      )}
      <div className={compact ? "relative" : "relative mt-2"}>
        <span
          aria-hidden="true"
          data-testid={`${testId}-currency-symbol`}
          className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm font-extrabold text-[#EA6A3B]"
        >
          {symbol}
        </span>
        <Input
          id={testId}
          data-testid={testId}
          type={type}
          className="h-12 rounded-lg pl-8"
          value={value}
          readOnly={readOnly}
          onChange={(event) => onChange?.(event.target.value)}
        />
      </div>
    </div>
  );
}
